import React from "react";
import { ValidationMessage } from "@components/validationMessage";

export const BaseDateValidationMessage = ({touched, errors, name}) => {
  const shouldShowBaseValidationMessage = 
    touched[name] && errors[name] && typeof errors[name] === "string";
  
  if (!shouldShowBaseValidationMessage) {
    return null;
  }
  
  return <ValidationMessage errorMessage={errors[name]} />
};